import { useEffect, useRef } from "react";

import { useChatData, useChatMessages } from "@chainlit/react-client";

import { useLayoutMaxWidth } from "hooks/useLayoutMaxWidth";

import { ErrorBoundary } from "../ErrorBoundary";
import ChatFooter from "./Footer";
import MessagesContainer from "./MessagesContainer";
import ScrollContainer from "./ScrollContainer";
import WelcomeScreen from "./WelcomeScreen";
import { cn, hasMessage } from "@/lib/utils";

const Chat = () => {
  const autoScrollRef = useRef(true);
  const { callFn } = useChatData();

  const { messages } = useChatMessages();
  const showWelcome = !hasMessage(messages);

  const layoutMaxWidth = useLayoutMaxWidth();

  useEffect(() => {
    if (callFn) {
      const event = new CustomEvent("chainlit-call-fn", {
        detail: callFn,
      });
      window.dispatchEvent(event);
    }
  }, [callFn]);

  useEffect(() => {
    const html = document.documentElement; // This selects the <html> tag

    if (!showWelcome) {
      html.classList.add("hide-scroll");
    } else {
      html.classList.remove("hide-scroll");
    }
  }, [showWelcome]);

  return (
    <div className={cn("chat-container", { "chat-full": !showWelcome })}>
      <div
        onBlur={undefined}
        onFocus={undefined}
        className={
          !showWelcome
            ? "max-w-[780px] p-[20px] mx-auto flex w-full h-full flex-col relative"
            : "max-w-[780px] mx-auto p-[20px]"
        }
      >
        <ErrorBoundary>
          {showWelcome && <WelcomeScreen autoScrollRef={autoScrollRef} />}

          {!showWelcome && (
            <ScrollContainer
              autoScrollUserMessage
              autoScrollRef={autoScrollRef}
            >
              <div
                className="container-messages flex flex-col mx-auto w-full flex-grow p-4"
                style={{
                  maxWidth: layoutMaxWidth,
                }}
              >
                <MessagesContainer />
              </div>
            </ScrollContainer>
          )}

          {!showWelcome && (
            <div
              className="flex flex-col mx-auto w-full p-4 pt-0 container-compose-message"
              style={{
                maxWidth: layoutMaxWidth,
              }}
            >
              <ChatFooter autoScrollRef={autoScrollRef} />
            </div>
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Chat;
